import api from "@/services/api";
import {
  SignedConventionStatsParams,
  SignedConventionStatsResponse,
} from "@/interfaces/SignedConventionStats";

export const signedConventionStatsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSignedConventionStats: build.query<
      SignedConventionStatsResponse,
      SignedConventionStatsParams
    >({
      query: (params) => ({
        url: "/admin/stats/signed-conventions",
        params,
      }),
      providesTags: [{ type: "SignedConventionStats", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const { useGetSignedConventionStatsQuery } = signedConventionStatsApi;
